import { createReducer, on } from '@ngrx/store';
import * as InfiniteScrollActions from './infinite-scroll.actions';
import { InfiniteScrollState } from './infinite-scroll.state';

export const initialState: InfiniteScrollState = {};

export const infiniteScrollReducer = createReducer(
  initialState,

  on(
    InfiniteScrollActions.addItems,
    (state, { key, items, pagination, itemUniquePropertyKey }) => {
      const existing = state[key]?.items ?? [];

      const map = new Map(
        [...existing, ...items].map((item) => [
          item[itemUniquePropertyKey],
          item,
        ])
      );

      return {
        ...state,
        [key]: {
          items: Array.from(map.values()),
          pagination,
          itemUniquePropertyKey,
        },
      };
    }
  ),

  on(InfiniteScrollActions.clearItems, (state, { key }) => {
    const { [key]: removed, ...rest } = state; //eslint-disable-line
    return rest;
  })
);
